import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "add-tracker" }
const _hoisted_2 = { class: "actions" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loader = _resolveComponent("Loader")
  const _component_CompanyTile = _resolveComponent("CompanyTile")
  const _component_CompanySearch = _resolveComponent("CompanySearch")
  const _component_TrackerSegment = _resolveComponent("TrackerSegment")
  const _component_ContactSearch = _resolveComponent("ContactSearch")
  const _component_RolesSelector = _resolveComponent("RolesSelector")
  const _component_TrackerSlider = _resolveComponent("TrackerSlider")
  const _component_TrackerButtongroup = _resolveComponent("TrackerButtongroup")
  const _component_TrackerTextarea = _resolveComponent("TrackerTextarea")
  const _component_ScrollBar = _resolveComponent("ScrollBar")
  const _component_Divider = _resolveComponent("Divider")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($options.loading)
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 0,
          class: "loader"
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "title" }, " Track Person ", -1 /* HOISTED */)),
          ($data.company)
            ? (_openBlock(), _createBlock(_component_CompanyTile, {
                key: 0,
                class: "company-info",
                name: $data.company.name,
                logo: $data.company.logo_url,
                type: $data.company.tracker_type
              }, null, 8 /* PROPS */, ["name", "logo", "type"]))
            : _createCommentVNode("v-if", true),
          _createVNode(_component_ScrollBar, {
            class: "settings",
            "bar-x-offset": "-2rem"
          }, {
            default: _withCtx(() => [
              (!$data.company)
                ? (_openBlock(), _createBlock(_component_TrackerSegment, {
                    key: 0,
                    title: "company",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CompanySearch, {
                        ref: "company",
                        modelValue: $data.chosen_company,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.chosen_company) = $event)),
                        required: "",
                        placeholder: "e.g. Acme"
                      }, null, 8 /* PROPS */, ["modelValue"])
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              _createVNode(_component_TrackerSegment, {
                title: "LinkedIn",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ContactSearch, {
                    ref: "linkedin",
                    modelValue: $data.contact,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.contact) = $event)),
                    "vread-from": "valid",
                    "onUpdate:valid": $event => (($data.valid) = $event),
                    type: "linkedin",
                    "company-name": $options.company_name,
                    class: "link",
                    title: "Linkedin",
                    required: "",
                    placeholder: "e.g. John Doe"
                  }, null, 8 /* PROPS */, ["modelValue", "onUpdate:valid", "company-name"])
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_TrackerSegment, { title: "buying role(s)" }, {
                default: _withCtx(() => [
                  _createVNode(_component_RolesSelector, {
                    modelValue: $data.tracker_roles,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.tracker_roles) = $event))
                  }, null, 8 /* PROPS */, ["modelValue"])
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_TrackerSegment, {
                title: "TRACKER SENSITIVITY",
                tooltip: "signal_sensitivity"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_TrackerSlider, {
                    modelValue: $options.slider_focus,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($options.slider_focus) = $event)),
                    class: "slider",
                    step: 50,
                    "show-tooltip": false,
                    greyed: $options.focus_text
                  }, null, 8 /* PROPS */, ["modelValue", "greyed"])
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_TrackerSegment, {
                title: "EMAIL ALERTS",
                tooltip: "email_notifications"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_TrackerButtongroup, {
                    modelValue: $data.tracker_alerts,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($data.tracker_alerts) = $event)),
                    options: $data.alerts,
                    class: "button-group"
                  }, null, 8 /* PROPS */, ["modelValue", "options"])
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_TrackerSegment, {
                title: "WHAT SHOULD WE WATCH FOR?",
                tooltip: "contact_customize_tracking"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_TrackerTextarea, {
                    modelValue: $data.focus_on,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($data.focus_on) = $event)),
                    title: "Focus tracking on:",
                    class: "textarea",
                    placeholder: "Track product launches, partnerships, and executive changes."
                  }, null, 8 /* PROPS */, ["modelValue"])
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_Divider, { m: "0 -2.4rem 2.4rem" }),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Button, {
              class: "delete-button",
              disabled: $data.saving,
              onClick: _cache[6] || (_cache[6] = $event => (_ctx.$dispatch('cancel')))
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode(" Cancel ")
              ])),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["disabled"]),
            _createVNode(_component_Button, {
              primary: "",
              loading: $data.saving,
              disabled: !$options.can_save,
              onClick: $options.onSave
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createTextVNode(" Start tracking ")
              ])),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["loading", "disabled", "onClick"])
          ])
        ], 64 /* STABLE_FRAGMENT */))
  ]))
}